import { ValentineScene3D } from './scene3d.js';
import { DayCharactersManager } from './dayCharacters3D.js';
import { AmbientMusicPlayer } from './audioPlayer.js';
import { SecretScratchCard } from './scratchCard.js';
import { ValentineCustomizer } from './customizer.js';
import { initScrollAndInteractions } from './scrollAnimation.js';
import { createIcons, Heart, Sparkles, Music, Share2, Volume2, Calendar, MapPin, Download, X, ArrowRight, ArrowLeft } from 'lucide';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Lucide Icons
  createIcons({
    icons: {
      Heart,
      Sparkles,
      Music,
      Share2,
      Volume2,
      Calendar,
      MapPin,
      Download,
      X,
      ArrowRight,
      ArrowLeft
    }
  });

  // 1. Initialize Hero 3D Canvas
  const canvasContainer = document.getElementById('webgl-canvas-container');
  let scene3D = null;
  if (canvasContainer) {
    scene3D = new ValentineScene3D(canvasContainer);
  }

  // 2. Initialize 3D Character Avatars for all 7 Days
  const dayCharactersManager = new DayCharactersManager();

  // 3. Initialize Ambient Music Player
  const musicPlayer = new AmbientMusicPlayer();

  // 4. Initialize Interactive Scratch Card
  new SecretScratchCard('scratch-canvas', 'scratch-container');

  // 5. Initialize Live Personalization Customizer
  new ValentineCustomizer();

  // 6. Initialize GSAP Scroll Timelines & Lenis
  initScrollAndInteractions(scene3D, dayCharactersManager, musicPlayer);
});
